import { fetchFeatures } from '../../redux/actions/login';
import { buildLoader } from '../util/GenericLoader';

export default buildLoader(fetchFeatures);
